import { render } from "./GratuityNotificationModal.component.vue?vue&type=template&id=3ca7b374&scoped=true"
import script from "./GratuityNotificationModal.component.vue?vue&type=script&lang=js"
export * from "./GratuityNotificationModal.component.vue?vue&type=script&lang=js"

import "./GratuityNotificationModal.component.vue?vue&type=style&index=0&id=3ca7b374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca7b374"]])

export default __exports__